import Product from './Product.js';
import ProductsKeyed from './ProductsKeyed.json';

const productList = Object.values(ProductsKeyed);

export default function Products(){
  return(
    <div>
      <div className="navigationOpacity">
        <div className="grid-container">
          <div className="grid-row">
            {productList.map((product) =>
              <Product
                key={product.name}
                name={product.name}
                price={product.price}
                supply={product.supply}
                imageExt={product.image_ext || 'jpg'}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
